<template>
  <v-container
    id="PasswordPromptUpdate"
  >
    <v-row
      class="d-flex justify-center"
    >
      <v-col
        cols="12"
        md="8"
        class="unskew"
      >
        <v-card
          elevation="1"
          outlined
          tile
        >
          <v-card-title class="px-18">
            Update your Password
          </v-card-title>
          <v-card-text>
            <error-component
              :show="showErrors"
              :errors="errors"
              :errors-array="errorsArray"
              @close="clear()"
            />
            <v-form
              v-model="valid"
            >
              <v-text-field
                v-model="email"
                disabled
                label="Email"
                filled
              />
              <v-text-field
                v-model="password"
                label="Current Password"
                filled
                :rules="Rules.required"
              />
              <v-text-field
                v-model="new_password"
                filled
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="New Password"
                :rules="[
                  ...Rules.required,
                  ...Rules.password,
                  !password_match ? 'Your passwords don\'t match' : true
                ]"
                hint="Password must be a minimum of 8 characters"
                counter
                @input="checkPasswordsMatch"
                @click:append="show1 = !show1"
              />
              <v-text-field
                v-model="confirm_password"
                filled
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                name="input-10-1"
                label="Confirm Password"
                :rules="[
                  ...Rules.password,
                  !password_match ? 'Your passwords don\'t match' : true
                ]"
                counter
                @input="checkPasswordsMatch"
                @click:append="show2 = !show2"
              />
            </v-form>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-btn
              id="resetButton"
              :disabled="!valid"
              :loading="loading"
              tile
              dark
              @click="resetPassword"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'PasswordPromptUpdateComponent',
  props: {
    email: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    show1: false,
    show2: false,
    timeout: '',
    valid: false,
    loading: false,
    password_match: false,
    password: '',
    new_password: '',
    confirm_password: '',
    showErrors: false,
    errors: {},
    errorsArray: []
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    checkPasswordsMatch () {
      const context = this
      clearTimeout(context.timeout)
      context.timeout = setTimeout(function () {
        context.password_match = context.new_password === context.confirm_password
      }, 500)
    },
    resetPassword () {
      this.loading = true
      const context = this
      const changePasswordUrl = this.URLs.core.users.updatePassword
      axios.post(changePasswordUrl, {
        password: this.password,
        new_password: this.new_password
      }).then(response => {
        window.location.href = '/dashboard'
      }).catch(error => {
        context.errors = error.response.data
        context.loading = false
        context.showErrors = true
      })
    },
    clear () {
      this.showErrors = false
      this.errors = {}
      this.errorsArray = []
    }
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
@import './resources/sass/agencyTheming';
#PasswordPromptUpdate {
  #resetButton{
    background-color: $agencyColorPrimary;

    &.v-btn--disabled {
      background-color: $agencyColorLightFaded!important;
      color: lightgrey;
    }
  }
  .unskew{
    max-width: 500px;
    transform: skewY(-10deg);
    color: white;
  @media screen and (min-width: 960px){
      transform: skewX(15deg);
      margin: 1rem 1rem;
      padding: 1rem 1rem;
    }
  }
}
</style>
